import { createContext, useContext, type ReactNode } from "react";

const DesignSystemContext = createContext(false);
const PlanningBaselineContext = createContext(false);

/** No layout box: the page owns geometry, and portals retain the same theme. */
export function DesignSystem({ enabled = true, scope = false, planningBaseline = false, children }: { enabled?: boolean; scope?: boolean; planningBaseline?: boolean; children: ReactNode }) {
  // A planning-origin dialog retains its original theme through nested editors
  // and React portals, even when a shared management component requests a scope.
  const baseline = useContext(PlanningBaselineContext) || planningBaseline;
  const themed = enabled && !baseline;
  return <PlanningBaselineContext value={baseline}><DesignSystemContext value={themed}>{themed && scope
    ? <div className="ui-next" style={{ display: "contents" }}>{children}</div>
    : children}</DesignSystemContext></PlanningBaselineContext>;
}

export const useDesignSystem = () => useContext(DesignSystemContext);
export const usePlanningBaseline = () => useContext(PlanningBaselineContext);

// Use canonical paths, not view names: another developer can change the home
// implementation without accidentally opting its address into this rollout.
// Authentication has its own light surface even when its destination is the
// planner. Never let a persisted planner theme recolor login/signup controls.
export const usesDesignSystem = (path: string, authenticated = true) => !authenticated || path !== "/" && path !== "/planner";
